/* eslint-disable */

import React, { useCallback, useEffect, useState } from "react";
import {
  Autocomplete,
  createFilterOptions,
  createTheme,
  TextField,
  ThemeProvider,
} from "@mui/material";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector, useDispatch } from "react-redux";
import {
  Button, IconButton, Modal,
} from "@material-ui/core";

import { DatePicker } from "../../../../shared/widgets";
import { passRevenueDetails } from "../../../../Constant";
import {
  clearOperatorPassRevenueAction,
  clearOperatorPassRevenueResponseAction,
  createOperatorPassRevenueAction,
} from "../../../../redux/action-creators/passRevenueActionCreator";
import { style4 as useStyles } from "../../../../styles/makeStyles";

const theme = createTheme({
  typography: {
    fontFamily: "Noto Sans",
  },
});

const updateStateFromRowData = (
  rowData,
  allCities,
  allOperators,
  setSelectedCity,
  setSelectedOperator,
  setTextFieldData,
  setDate,
) => {
  if (Object.keys(rowData).length) {
    setSelectedCity(
      allCities.find((city) => city?.cityId === rowData?.cityId),
    );
    setSelectedOperator(
      allOperators.find(
        (operator) => operator?.operatorId === rowData?.operatorId?.toString(),
      ),
    );
    setTextFieldData({
      superSaverPassRevenue: rowData.superSaverPassRevenue,
      magicPassRevenue: rowData.magicPassRevenue,
    });
    setDate(rowData.ymd);
  }
};

const updateNewData = (
  rowData,
  textFieldData,
  newData,
) => {
  if (rowData.magicPassRevenue && !textFieldData.magicPassRevenue) {
    // eslint-disable-next-line no-param-reassign
    newData.magicPassRevenue = 0;
  }
  if (
    rowData.superSaverPassRevenue
    && !textFieldData.superSaverPassRevenue
  ) {
    // eslint-disable-next-line no-param-reassign
    newData.superSaverPassRevenue = 0;
  }
}

const createOrUpdateOperatorPassRevenue = ({
  selectedCity,
  selectedOperator,
  textFieldData,
  rowData,
  date,
  isCloseModal,
  dispatch,
}) => {
  if (
    selectedCity?.cityId
    && selectedOperator?.operatorId
    && date
    && (Object.keys(textFieldData).length || Object.keys(rowData).length)
  ) {
    if (Object.keys(rowData).length) {
      const newData = {
        magicPassRevenue: rowData.magicPassRevenue,
        superSaverPassRevenue: rowData.superSaverPassRevenue,
        ...textFieldData,
      };
      updateNewData(
        rowData,
        textFieldData,
        newData,
      );
      dispatch(
        createOperatorPassRevenueAction({
          cityId: selectedCity?.cityId?.toString(),
          operatorId: selectedOperator?.operatorId,
          date,
          passRevenueDetails: newData,
          isCloseModal,
        }),
      );
    } else {
      dispatch(
        createOperatorPassRevenueAction({
          cityId: selectedCity?.cityId?.toString(),
          operatorId: selectedOperator?.operatorId,
          date,
          passRevenueDetails: textFieldData,
          isCloseModal,
        }),
      );
    }
  }
}

const filterOperatorsByCityId = (
  selectedCity,
  setOperatorsList,
  allOperators,
) => {
  if (selectedCity.cityId) {
    setOperatorsList(
      allOperators.filter(
        (item) => item?.cityId === selectedCity?.cityId?.toString(),
      ),
    );
  } else {
    setOperatorsList(allOperators);
  }
};

const updateTextFieldData = (
  value,
  id,
  textFieldData,
  setTextFieldData,
) => {
  if (value === "") {
    delete textFieldData[id];
    setTextFieldData({ ...textFieldData });
  } else if (!isNaN(Number(value)) && Number(value) >= 0) {
    setTextFieldData({ ...textFieldData, [id]: Number(value) });
  }
};

const updateDate = (dateProp, setDate) => {
  if (dateProp) {
    setDate(moment(dateProp).format("YYYY-MM-DD").toString());
  }
};

const getDateInDatePicker = (rowData, date) => {
  const newDate = rowData?.date || date;
  return newDate ? moment(newDate) : null;
};

const buttonDisabledCondition = (
  selectedCity,
  selectedOperator,
  date,
  textFieldData,
  rowData,
) => {
  const extraConditon = rowData ? !Object.keys(rowData).length : true;
  return (!selectedCity?.cityId
    || !selectedOperator?.operatorId
    || !date
    || (!Object.keys(textFieldData).length && extraConditon)
  );
};

const passRevenueTextField = (textFieldData, item) => (textFieldData[item] >= 0 ? textFieldData[item] : "");

function PassRevenueModal(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    open, setOpen, rowData = {}, setRefresh,
  } = props;

  const allOperators = useSelector((state) => state.Operators.operators);
  const createOperatorPassRevenueResponse = useSelector(
    (state) => state?.PassRevenue?.createOperatorPassRevenueResponse,
  );
  const allCities = useSelector(
    (state) => state.PassRevenue.passRevenueCities || [],
  );

  const [textFieldData, setTextFieldData] = useState({});
  const [operatorsList, setOperatorsList] = useState(allOperators);
  const [selectedCity, setSelectedCity] = useState({});
  const [selectedOperator, setSelectedOperator] = useState({});
  const [date, setDate] = useState();

  useEffect(() => {
    updateStateFromRowData(
      rowData,
      allCities,
      allOperators,
      setSelectedCity,
      setSelectedOperator,
      setTextFieldData,
      setDate,
    )
  }, []);

  const handleClose = useCallback(() => {
    setOpen(!open);
  }, [open, setOpen]);

  const saveData = useCallback(
    ({ isCloseModal }) => {
      createOrUpdateOperatorPassRevenue({
        selectedCity,
        selectedOperator,
        textFieldData,
        rowData,
        date,
        isCloseModal,
        dispatch,
    })
    },
    [
      selectedCity?.cityId,
      selectedOperator?.operatorId,
      date,
      textFieldData,
      props,
      setRefresh,
    ],
  );

  useEffect(() => {
    if (
      createOperatorPassRevenueResponse?.success
      && createOperatorPassRevenueResponse?.isCloseModal
    ) {
      handleClose();
      dispatch(clearOperatorPassRevenueResponseAction());
      setRefresh(true);
    } else if (
      createOperatorPassRevenueResponse?.success
      && !createOperatorPassRevenueResponse?.isCloseModal
    ) {
      setTextFieldData({});
      setOperatorsList(allOperators);
      setSelectedCity({});
      setSelectedOperator({});
      setDate();
      dispatch(clearOperatorPassRevenueAction());
      setRefresh(true);
    }
  }, [createOperatorPassRevenueResponse]);

  const handleSaveClose = useCallback(() => {
    saveData({ isCloseModal: true });
  }, [saveData]);

  const handleSaveContinue = useCallback(() => {
    saveData({ isCloseModal: false });
  }, [saveData]);

  useEffect(() => {
    filterOperatorsByCityId(
      selectedCity,
      setOperatorsList,
      allOperators,
    )
  }, [selectedCity, allOperators]);

  const handleTextFieldChange = useCallback(
    (id, value) => {
      updateTextFieldData(
        value,
        id,
        textFieldData,
        setTextFieldData,
      )
    },
    [textFieldData],
  );

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    stringify: (option) => (option.displayName ?? option.cityName),
    limit: 500,
  });

  const renderOption = (renderProps, option) => (
    <li
      {...renderProps}
      key={option?.operatorId ?? option.cityId}
    >
      {option.displayName ?? option.cityName}
    </li>
  );

  const handleDatesChange = (dateProp) => {
    updateDate(dateProp, setDate);
  };

  return (
    <ThemeProvider theme={theme}>
      <Modal open={open} onClose={handleClose} className={classes.modal}>
        <div className={classes.container}>
          <div className={classes.contentWrapper}>
            <div className={classes.header}>
              {Object.keys(rowData).length ? (
                <h3 className={classes.headingThree}>Edit Pass Revenue</h3>
              ) : (
                <h3 className={classes.headingThree}>New Pass Revenue</h3>
              )}
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
            <div className={classes.dateWrapper}>
              <DatePicker
                date={ getDateInDatePicker(rowData, date) }
                label="Enter Pass Revenue Date"
                onDateChange={handleDatesChange}
                className={classes.customDatePickerCss}
              />
            </div>
            <div className={classes.autoCompleteWrapper}>
              <Autocomplete
                className={classes.autoComplete}
                value={selectedCity}
                getOptionLabel={(option) => option.cityName || ""}
                options={allCities}
                filterOptions={filterOptions}
                onChange={(event, newValue) => {
                  setSelectedCity(newValue || {});
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select City"
                    variant="standard"
                  />
                )}
                renderOption={renderOption}
              />
              <Autocomplete
                className={classes.autoComplete}
                value={selectedOperator}
                getOptionLabel={(option) => option.displayName || ""}
                options={operatorsList}
                filterOptions={filterOptions}
                onChange={(event, newValue) => {
                  setSelectedOperator(newValue || {});
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Operator"
                    variant="standard"
                  />
                )}
                renderOption={renderOption}
              />
            </div>
            <h4 className={classes.headingFour}>Pass Revenue</h4>
            <div className={classes.itemWrapper}>
              {Object.keys(passRevenueDetails).map((item) => (
                <TextField
                  id={`${item}`}
                  className={classes.textField}
                  label={passRevenueDetails[item]?.displayName}
                  onChange={(e) => {
                    handleTextFieldChange(item, e.target.value);
                  }}
                  value={passRevenueTextField(textFieldData, item)}
                  variant="standard"
                />
              ))}
            </div>
            <h4 className={classes.total} />
            <div className={classes.footerWrapper}>
              <Button
                variant="contained"
                className={classes.cancel}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                className={classes.saveClose}
                variant="outlined"
                onClick={handleSaveClose}
                disabled={buttonDisabledCondition(
                  selectedCity,
                  selectedOperator,
                  date,
                  textFieldData,
                  rowData,
                )}
              >
                Save and Close
              </Button>
              {!Object.keys(rowData).length && (
                <Button
                  className={classes.saveContinue}
                  variant="contained"
                  onClick={handleSaveContinue}
                  disabled={buttonDisabledCondition(
                    selectedCity,
                    selectedOperator,
                    date,
                    textFieldData,
                  )}
                >
                  Save and Continue
                </Button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </ThemeProvider>
  );
}
export default PassRevenueModal;
